module.exports = __webpack_public_path__ + "static/team-16-4d3c298a3010d2d0b4e98f32c0dc13e2.jpg";